

export const  NotificationType = {
    SUCCESS: 'success',
    ERROR: 'error',
};